<i18n>
{
  "en": {
    "related_videos": "Related Videos",
    "vip_badge": "VIP",
    "svip_badge": "SVIP",
    "annual_badge": "Annual",
    "limited_tag": "Limited Availability",
    "expired_tag": "Availability Ended",
    "future_tag": "Upcoming"
  },
  "ja": {
    "related_videos": "関連動画",
    "vip_badge": "VIP",
    "svip_badge": "超VIP",
    "annual_badge": "年間",
    "limited_tag": "期間限定",
    "expired_tag": "配信期間終了",
    "future_tag": "近日配信"
  }
}
</i18n>

<template>
<div class="movie-related section">
  <h2 class="is-primary">{{ $t('related_videos') }}</h2>
  <div class="grid is-movie is-compact">
    <div class="grid-item" v-for="(movie, index) in movieListRelated" :key="movie.MovieID">
      <router-link class="entry" :to="`/movies/${movie.MovieID}/`">
        <div class="entry-media">
          <img class="media-image"
            :src="movie.thumbnailSrc"
            @error="useFallbackImage(index)"
            width="480"
            height="270"
            loading="lazy"
            alt=""
            v-sfw>
        </div>
        <div class="entry-meta">
          <div class="meta-date">{{ movie.ReleaseDate }}<span v-if="movie.ExpireDate"> &ndash; {{ movie.ExpireDate }}</span></div>
          <div class="meta-title">
            <span v-if="!newXPEligible && movie.isVIP" class="tag-member is-vip">{{ $t('vip_badge') }}</span>
            <span v-if="!newXPEligible && movie.isSVIP" class="tag-member is-svip">{{ $t('svip_badge') }}</span>
            <span v-if="!newXPEligible && movie.isAnnual" class="tag-member is-annual">{{ $t('annual_badge') }}</span>
            <span v-if="locale === 'ja'">{{ movie.Title }}</span>
            <span v-if="locale === 'en'">{{ movie.TitleEn || movie.ActressesEn.join(', ') }}</span>
          </div>
          <div class="meta-status">
            <div v-if="movie.IsLimited" class="tag-status is-limited">{{ $t('limited_tag') }}</div>
            <div v-if="movie.IsExpired" class="tag-status is-expired">{{ $t('expired_tag') }}</div>
            <div v-if="movie.IsComingSoon" class="tag-status is-future">{{ $t('future_tag') }}</div>
            <div v-if="movie.isVR" class="tag-status is-vr">{{ $t('vr_tag') }}</div>
          </div>
        </div>
      </router-link>
    </div>
  </div>
</div>
</template>

<script>
/* eslint max-len: 0 */

import BifrostAPI from '@/assets/js/services/Bifrost/API';
import MovieHelper from '@/assets/js/utils/movie';

export default {
  props: {
    numMovies: Number,
  },
  data() {
    return {
      movieListRelated: [],
      isDisabled: false,
      posterFallbackTries: {},
    };
  },
  created() {
    this.getRelatedMovies(this.userTypeID);
  },
  methods: {
    async getRelatedMovies(userTypeID) {
      const bfAPI = new BifrostAPI();
      // get movie data + related movie info if we're on a movie detail page
      if (this.$route.name === 'movie-detail') {
        const movie = await bfAPI.getMovieDetail(this.$route.params.movieId);
        if (Object.prototype.hasOwnProperty.call(movie, 'MetaMovieID')) {
          const cats = await bfAPI.getCatAssoc(movie.MetaMovieID);
          const movieListRelated = MovieHelper.expandDetailsList(cats.Rows.slice(0, parseInt(this.numMovies, 10)), this.locale, userTypeID);
          this.movieListRelated = MovieHelper.filterExcludedMovieList(movieListRelated, userTypeID);
        }
      }
    },
    useFallbackImage(index) {
      // large poster is missing, use no-image placeholder
      this.$set(this.movieListRelated[index], 'thumbnailSrc', '/img/common/now_printing.png');
    },
  },
  computed: {
    locale() {
      return this.$i18n.locale;
    },
    newXPEligible() {
      return this.$store.getters['user/isNewXPEligible'];
    },
    userTypeID() {
      return this.$store.getters['user/typeID'];
    },
  },
  watch: {
    userTypeID(newVal) {
      this.posterFallbackTries = {}; // reset fallback states
      this.getRelatedMovies(newVal);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/sass/pages/_detail.scss';
</style>
